// extracted by mini-css-extract-plugin
module.exports = {"editor":"Editor_editor__k8PhM","progressPlaceHolder":"Editor_progressPlaceHolder__3Os4G"};